/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { Box, Button, IconButton, Tooltip, textField } from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import { ReactComponent as Reload } from 'src/assets/icons/reload.svg';
import { ReactComponent as Add } from 'src/assets/icons/oldPortal/adicionar.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';
import { ReactComponent as SearchIcon } from 'src/assets/icons/searchFolder.svg';

import { ReactComponent as Trash } from 'src/assets/icons/trash.svg';
import { ReactComponent as Edit } from 'src/assets/icons/edit.svg';

import {
  DeleteDynamic,
  GetDynamic,
  GetProcesso,
  isValid,
} from 'src/services/auth';
import { LoadGif } from '../LoadGif';
import CustomInput, { MaskInput, SelectInput } from '../customInput';
import showToast from '../toastyService';

const data = [];
const columns = [
  /*{
    accessorKey: 'IS_ADM',
    header: 'Administrador',
  },*/
  {
    accessorKey: 'id',
    header: 'Id',
  },
  {
    accessorKey: 'nome',
    header: 'Nome',
  },
  {
    accessorKey: 'id_empresa',
    header: 'Empresa',
  },
  {
    accessorKey: 'situacao',
    header: 'Situação',
  },
  /*{
    accessorKey: 'CPF',
    header: 'Cpf',
    Cell: ({ cell }) => {
      const raw = cell.getValue() || '';
      const cleaned = raw.replace(/\D/g, '').padStart(11, '0');
      const masked = cleaned.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
        '$1.$2.$3-$4'
      );
      return masked;
    },
  },*/
];

export default function User({ Disabled }) {
  const isAdm =
    localStorage.getItem('admPerm') === 'S' || localStorage.getItem('admPerm');

  const [load, setLoad] = useState(false);
  const [showPopup, setShowPopup] = useState('');

  const [optionsEmpresas, setOptionsEmpresas] = useState();
  const [optionsGrupos, setOptionsGrupos] = useState();

  const [userData, setUserData] = useState([]);
  const [userFilter, setUserFilter] = useState([]);

  const [selectedRow, setSelectedRow] = useState({});

  useEffect(() => {
    if (!isValid(optionsEmpresas)) {
      const data = {};

      GetDynamic('GET', 'empresas').then((response) => {
        const optionsObject = (Array.isArray(response) ? response : []).reduce(
          (acc, option) => {
            acc[option.id] = option.nome;
            return acc;
          },
          {}
        );

        setOptionsEmpresas(optionsObject);
      });

      /*getGrupos().then((response) => {
        const optionsObject = response.reduce((acc, option) => {
          acc[option.IDUSERGROUP] = option.NOMEGRUPO;
          return acc;
        }, {});

        setOptionsGrupos(optionsObject);
      });*/
    }
  }, []);

  const todosHorarios = [
    {
      Dia: 'DOM',
      Inicio: '00:00',
      Fim: '23:00',
    },
    {
      Dia: 'SEG',
      Inicio: '00:00',
      Fim: '23:00',
    },
    {
      Dia: 'TER',
      Inicio: '00:00',
      Fim: '23:00',
    },
    {
      Dia: 'QUA',
      Inicio: '00:00',
      Fim: '23:00',
    },
    {
      Dia: 'QUI',
      Inicio: '00:00',
      Fim: '23:00',
    },
    {
      Dia: 'SEX',
      Inicio: '00:00',
      Fim: '23:00',
    },
    {
      Dia: 'SAB',
      Inicio: '00:00',
      Fim: '23:00',
    },
  ];

  const [newUser, setNewUser] = useState({});
  const [clearUser, setClearUser] = useState({
    id_empresa: '',
    id_usuario: '',
    nome: '',
    situacao: '',
  });

  const ClearParameters = {
    id: '',
    id_empresa: '',
    id_usuario: '',
    nome: '',
    situacao: '',
    created_at: '',
    updated_at: '',
    nome_empresa: '',
  };

  const [parametros, setParametros] = useState(ClearParameters);
  const [validate, setValidate] = useState([]);

  function timedLoad(time) {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, time);
  }

  function handleConsulta() {
    setLoad(true);

    GetDynamic('GET', `usuarios`)
      .then((response) => {
        setLoad(false);
        filterUser(response);
      })
      .catch(() => {
        setLoad(false);
      });
  }

  function handleAdd() {
    const emptyParams = Object.entries(newUser)
      .filter(([key, value]) => value.trim() === '')
      .map(([key]) => key);

    if (emptyParams.length > 0) {
      setValidate(emptyParams);
      return;
    }

    const data = {
      id_empresa: newUser.id_empresa,
      id_usuario: newUser.id_usuario,
      nome: newUser.nome,
      situacao: newUser.situacao,
    };

    GetDynamic('POST', 'usuarios', data)
      .then((res) => {
        setShowPopup('');
        handleConsulta();
      })
      .catch((error) => showToast('error', error));
  }

  function handleDelete() {
    DeleteDynamic(`usuarios/${selectedRow.id}`)
      .then((res) => {
        setShowPopup('');
        handleConsulta();
      })
      .catch((error) => showToast('error', error));
  }

  function handleEdit() {
    const emptyParams = Object.entries(newUser)
      .filter(
        ([_, value]) => value === undefined || String(value).trim() === ''
      )
      .map(([key]) => key);

    if (emptyParams.length > 0) {
      setValidate(emptyParams);
      return;
    }

    const data = {
      id_empresa: newUser.id_empresa,
      id_usuario: newUser.id_usuario,
      nome: newUser.nome,
      situacao: newUser.situacao,
    };

    GetDynamic('PUT', `usuarios/${selectedRow.id}`, data)
      .then((res) => {
        setShowPopup('');
        handleConsulta();
      })
      .catch((error) => showToast('error', error));
  }

  function filterUser(data) {
    const filtrado = data.filter((user) =>
      Object.entries(parametros).some(
        ([key, val]) =>
          val !== '' &&
          String(user[key]).toLowerCase().includes(String(val).toLowerCase())
      )
    );

    if (Object.values(parametros).some((item) => isValid(item)))
      setUserFilter(filtrado);
    else setUserFilter(data);
  }

  const isMobile = window.innerWidth <= 768;
  const user = useMaterialReactTable({
    columns,
    data: userFilter,

    enablePagination: 'true',
    paginationDisplayMode: 'pages',
    enableRowActions: 'true',
    enableStickyHeader: true,
    enableStickyFooter: true,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    initialState: {
      showGlobalFilter: true,
      density: 'compact',
      columnPinning: !isMobile
        ? { left: ['mrt-row-select', 'mrt-row-actions'] }
        : {},
      pagination: { pageSize: 15 },
    },

    muiTopToolbarProps: {
      className: 'myTable-toolbar',
    },

    muiTableContainerProps: {
      sx: {
        flex: 1,
        height: '100%',
        maxHeight: 'calc(100% - 6.5rem)',
        overflow: 'auto',
      },
    },

    muiTablePaperProps: {
      sx: {
        boxShadow: 'none',
      },
    },

    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: true,
      variant: 'outlined',
    },

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Deletar">
          <IconButton
            onClick={() => {
              setShowPopup('delete');
              setSelectedRow(row.original);
            }}
          >
            <Trash className="tableIcon line" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              setShowPopup('edit');
              setSelectedRow(row.original);
              setNewUser({
                nome: row.original.nome,
                id_usuario: row.original.id_usuario,
                situacao: row.original.situacao,
                id_empresa: row.original.id_empresa,
              });
              setValidate([]);
            }}
          >
            <Edit className="tableIcon line" />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    localization: MRT_Localization_PT_BR,
  });

  return (
    <div className={`User ${Disabled && 'hide'}`}>
      {load && <LoadGif />}

      <div className="controls">
        <button
          onClick={() => {
            setValidate([]);
            setNewUser(clearUser);
            setShowPopup('add');
          }}
          className="mainButton turquoise"
        >
          <Add />
          Adicionar
        </button>

        <button
          onClick={() => {
            setShowPopup('busca');
            setParametros(ClearParameters);
          }}
          className="mainButton yellow"
        >
          <SearchIcon />
          Consultar
        </button>

        <button
          onClick={() => handleConsulta()}
          className={`mainButton turquoise reload ${load && ' loading'}`}
        >
          <Reload />
        </button>
      </div>

      {showPopup === 'busca' && (
        <div className="modal consulta absoluteCenter">
          <h2> Filtros </h2>

          <div className="inputs">
            <SelectInput
              PlaceHolder="Situação"
              OnChange={(newValue) => {
                setParametros((prev) => ({
                  ...prev,
                  situacao: newValue.target.value,
                }));
              }}
              Options={{ S: 'Sim', N: 'Não' }}
            />

            <CustomInput
              OnChange={(newValue) => {
                setParametros((prev) => ({
                  ...prev,
                  id: newValue.target.value,
                }));
              }}
              Type="number"
              PlaceHolder="Id"
            />

            {/*<MaskInput
              OnChange={(newValue) => {
                const rawValue =
                  newValue?.target?.value?.replace(/\D/g, '') || '';
                setParametros((prev) => ({
                  ...prev,
                  CPF: rawValue,
                }));
              }}
              Type="text"
              PlaceHolder="Cpf"
              Mask="999.999.999-99"
            />*/}

            {/*{isAdm && (
              <SelectInput
                OnChange={(newValue) => {
                  setParametros((prev) => ({
                    ...prev,
                    IDEMPRESA: newValue.target.value,
                  }));
                }}
                Options={optionsEmpresas}
                PlaceHolder="Empresa"
              />
            )}*/}

            {!isAdm && (
              <SelectInput
                OnChange={(newValue) => {
                  setParametros((prev) => ({
                    ...prev,
                    id_empresa: newValue.target.value,
                  }));
                }}
                Options={optionsEmpresas}
                PlaceHolder="Empresa (NoADM)"
              />
            )}
          </div>

          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>

            <button
              onClick={() => {
                handleConsulta();
                setShowPopup('');
              }}
              className="mainButton turquoise"
            >
              <SearchIcon />
              Buscar
            </button>
          </div>
        </div>
      )}

      {showPopup === 'add' && (
        <div className="modal absoluteCenter add">
          <h2> Adicionar Usuários </h2>

          <div className="inputs">
            <CustomInput
              Class={`${validate.includes('nome') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, nome: e.target.value }))
              }
              Type="text"
              PlaceHolder="Nome *"
            />

            <CustomInput
              Class={`${validate.includes('nome') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, id_usuario: e.target.value }))
              }
              Type="text"
              PlaceHolder="Id *"
              DefaultValue="novo.usuario"
            />

            <SelectInput
              Class={`${validate.includes('idemp') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, id_empresa: e.target.value }))
              }
              PlaceHolder="Empresa *"
              Options={optionsEmpresas}
            />

            <SelectInput
              Class={`${validate.includes('situacao') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, situacao: e.target.value }))
              }
              Options={{ S: 'Ativo', N: 'Não Ativo' }}
              PlaceHolder="Situação *"
              DefaultValue={newUser.situacao}
            />

            {isValid(validate) && (
              <span className="error">
                * Items obrigatórios não preenchidos
              </span>
            )}
          </div>

          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>

            <button
              onClick={() => {
                handleAdd();
              }}
              className="mainButton turquoise"
            >
              <Add />
              Adicionar
            </button>
          </div>
        </div>
      )}

      {showPopup === 'edit' && (
        <div className="modal absoluteCenter edit">
          <h2> Editar {selectedRow.NOME} </h2>

          <div className="inputs">
            <CustomInput
              Class={`${validate.includes('nome') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, nome: e.target.value }))
              }
              Type="text"
              PlaceHolder="Nome *"
              DefaultValue={newUser.nome}
            />

            <CustomInput
              Class={`${validate.includes('nome') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, id_usuario: e.target.value }))
              }
              Type="text"
              PlaceHolder="Id *"
              DefaultValue={newUser.id_usuario}
            />

            <SelectInput
              Class={`${validate.includes('id_empresa') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, id_empresa: e.target.value }))
              }
              PlaceHolder="Empresa *"
              Options={optionsEmpresas}
              DefaultValue={newUser.id_empresa}
            />

            <SelectInput
              Class={`${validate.includes('situacao') ? 'mark ' : ''}`}
              OnChange={(e) =>
                setNewUser((prev) => ({ ...prev, situacao: e.target.value }))
              }
              Options={{ S: 'Ativo', N: 'Não Ativo' }}
              PlaceHolder="Situação *"
              DefaultValue={newUser.situacao}
            />

            {isValid(validate) && (
              <span className="error">
                * Items obrigatórios não preenchidos
              </span>
            )}
          </div>

          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>

            <button
              onClick={() => {
                handleEdit();
              }}
              className="mainButton yellow"
            >
              <Edit />
              Salvar
            </button>
          </div>
        </div>
      )}

      {showPopup === 'delete' && (
        <div className="modal absoluteCenter delete">
          <h3>Deletar: </h3>
          <h4>
            {selectedRow.id} | {selectedRow.nome}
          </h4>
          <div className="controls">
            <button
              onClick={() => setShowPopup('')}
              className="mainButton gray"
            >
              <End />
              Cancelar
            </button>

            <button onClick={() => handleDelete()} className="mainButton red">
              <Trash /> Confirmar
            </button>
          </div>
        </div>
      )}

      <div className="tableWrapper">
        {(load || showPopup !== '') && (
          <button onClick={() => setShowPopup('')} className="fade" />
        )}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            borderRadius: '0.5rem',
            overflow: 'hidden',
          }}
        >
          <MaterialReactTable table={user} />
        </Box>
      </div>
    </div>
  );
}

User.propTypes = {
  Disabled: PropTypes.bool,
};
